import type { ReactNode } from 'react';
import React from 'react';

import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';

import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay.ts';

export type ChangeHistoryErrorDisplayProps = {
	error: Error;
	children: ReactNode;
};

export const ChangeHistoryErrorDisplay = ({
	error,
	children,
}: ChangeHistoryErrorDisplayProps): React.JSX.Element => (
	<ErrorDisplay error={error}>
		<Box padding="space.100">
			<Text>{children}</Text>
		</Box>
	</ErrorDisplay>
);
